import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", null, "Transactions", -1 /* HOISTED */)
const _hoisted_2 = { class: "transactions-page__actions" }
const _hoisted_3 = { class: "transactions-page__actions_round-wrapper" }
const _hoisted_4 = { key: 6 }
const _hoisted_5 = { key: 7 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_ColumnFilter = _resolveComponent("ColumnFilter")!
  const _component_el_container = _resolveComponent("el-container")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_popover = _resolveComponent("el-popover")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_TransactionsFilter = _resolveComponent("TransactionsFilter")!
  const _component_ListFilterSidebar = _resolveComponent("ListFilterSidebar")!
  const _component_TokenPagination = _resolveComponent("TokenPagination")!
  const _component_TwoFactorAuthDialog = _resolveComponent("TwoFactorAuthDialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_container, { class: "transactions-page__header" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createElementVNode("div", _hoisted_2, [
          (_ctx.isTransactionsDownloadCvsAllowed)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                icon: _ctx.icons.Download,
                loading: _ctx.isTransactionListReportLoading,
                disabled: _ctx.isTransactionListLoading,
                type: "primary",
                plain: "",
                onClick: _ctx.openTwoFactorDialog
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Report ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["icon", "loading", "disabled", "onClick"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_button, {
              loading: false,
              round: "",
              icon: _ctx.icons.Filter,
              onClick: _ctx.openFilter
            }, {
              default: _withCtx(() => [
                _createTextVNode(" Filters "),
                (_ctx.isFilterActive)
                  ? (_openBlock(), _createBlock(_component_el_tag, {
                      key: 0,
                      class: "transactions-page__filter-tag",
                      effect: "dark",
                      round: "",
                      size: "small"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.activeFiltersCount), 1 /* TEXT */)
                      ]),
                      _: 1 /* STABLE */
                    }))
                  : _createCommentVNode("v-if", true)
              ]),
              _: 1 /* STABLE */
            }, 8 /* PROPS */, ["icon", "onClick"]),
            _createVNode(_component_ColumnFilter, {
              "storage-key": _ctx.transactionListColumnsStorageKey,
              "original-columns": _ctx.originalColumns,
              "is-disabled": _ctx.isTransactionListLoading,
              onUpdateColumns: _ctx.updateColumns,
              onResetColumns: _ctx.resetColumns
            }, null, 8 /* PROPS */, ["storage-key", "original-columns", "is-disabled", "onUpdateColumns", "onResetColumns"]),
            _createVNode(_component_el_button, {
              circle: "",
              icon: _ctx.icons.Refresh,
              loading: _ctx.isTransactionListsLoading,
              onClick: _ctx.refreshData
            }, null, 8 /* PROPS */, ["icon", "loading", "onClick"])
          ])
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_el_container, { class: "transactions-page__content" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          size: "small",
          class: "transactions-page__table",
          "tooltip-effect": "light",
          data: _ctx.transactionListWithFormattedDates,
          border: "",
          onSortChange: _ctx.changeColumnSort
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.originalColumns, (column) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: column.value
              }, [
                (column.isVisible)
                  ? (_openBlock(), _createBlock(_component_el_table_column, {
                      key: 0,
                      prop: column.value,
                      label: column.label,
                      "min-width": column.width,
                      align: column.align,
                      sortable: column.isSortable ? 'custom' : false
                    }, {
                      default: _withCtx(({ row }) => [
                        (column.value === _ctx.TransactionListColumnProperties.PLAYER_EMAIL)
                          ? (_openBlock(), _createBlock(_component_el_link, {
                              key: 0,
                              class: "transactions-page__link",
                              type: "primary",
                              underline: false,
                              onClick: ($event: any) => (_ctx.openPlayerProfile(row.playerId))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(row[column.value]), 1 /* TEXT */)
                              ]),
                              _: 2 /* DYNAMIC */
                            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                          : (column.value === _ctx.TransactionListColumnProperties.OPERATION)
                            ? (_openBlock(), _createBlock(_component_el_tag, {
                                key: 1,
                                type: _ctx.getOperationStatusTagType(row[column.value])
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(row[column.value]), 1 /* TEXT */)
                                ]),
                                _: 2 /* DYNAMIC */
                              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"]))
                            : (column.value === _ctx.TransactionListColumnProperties.TRANSACTION_STATUS)
                              ? (_openBlock(), _createBlock(_component_el_popover, {
                                  key: 2,
                                  disabled: row.transactionStatus !== _ctx.PaymentStatuses.HOLD || !row.currentStatusReason,
                                  placement: "top",
                                  trigger: "hover"
                                }, {
                                  reference: _withCtx(() => [
                                    _createVNode(_component_el_tag, {
                                      type: _ctx.paymentStatusTagTypes[row[column.value]]
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.getTransactionStatusText(row[column.value])), 1 /* TEXT */)
                                      ]),
                                      _: 2 /* DYNAMIC */
                                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"])
                                  ]),
                                  default: _withCtx(() => [
                                    _createElementVNode("small", null, [
                                      _createVNode(_component_el_icon, { color: "#67c23a" }, {
                                        default: _withCtx(() => [
                                          (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.icons.InfoFilled)))
                                        ]),
                                        _: 1 /* STABLE */
                                      }),
                                      _createTextVNode(" Transaction status info ")
                                    ]),
                                    _createElementVNode("div", null, _toDisplayString(row.currentStatusReason), 1 /* TEXT */)
                                  ]),
                                  _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled"]))
                              : (column.value === _ctx.TransactionListColumnProperties.PAYMENT_STATUS_INFO)
                                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 3 }, _renderList(row[column.value], (paymentStatusInfo, index) => {
                                    return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(paymentStatusInfo), 1 /* TEXT */))
                                  }), 128 /* KEYED_FRAGMENT */))
                                : (column.value === _ctx.TransactionListColumnProperties.AUTO_APPROVE_REJECT_BY_RULE_LIST)
                                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 4 }, _renderList(row[column.value], (rule, index) => {
                                      return (_openBlock(), _createElementBlock("div", { key: index }, _toDisplayString(rule), 1 /* TEXT */))
                                    }), 128 /* KEYED_FRAGMENT */))
                                  : (column.value === _ctx.TransactionListColumnProperties.PAYMENT_ACCOUNT)
                                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                                        _createElementVNode("div", null, _toDisplayString(row.paymentAccount), 1 /* TEXT */),
                                        _createElementVNode("div", null, _toDisplayString(row.cryptoAddress), 1 /* TEXT */),
                                        _createElementVNode("div", null, _toDisplayString(row.cryptoAddressTag), 1 /* TEXT */)
                                      ], 64 /* STABLE_FRAGMENT */))
                                    : (column.value === _ctx.TransactionListColumnProperties.LAST_NAME)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(row.user[_ctx.TransactionListColumnProperties.LAST_NAME]), 1 /* TEXT */))
                                      : (column.value === _ctx.TransactionListColumnProperties.FIRST_NAME)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(row.user[_ctx.TransactionListColumnProperties.FIRST_NAME]), 1 /* TEXT */))
                                        : (column.value === _ctx.TransactionListColumnProperties.FIRST_DEPOSIT)
                                          ? (_openBlock(), _createBlock(_component_el_tag, {
                                              key: 8,
                                              type: "info"
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(_toDisplayString(row[column.value]), 1 /* TEXT */)
                                              ]),
                                              _: 2 /* DYNAMIC */
                                            }, 1024 /* DYNAMIC_SLOTS */))
                                          : (_openBlock(), _createElementBlock(_Fragment, { key: 9 }, [
                                              _createTextVNode(_toDisplayString(row[column.value]), 1 /* TEXT */)
                                            ], 64 /* STABLE_FRAGMENT */))
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop", "label", "min-width", "align", "sortable"]))
                  : _createCommentVNode("v-if", true)
              ], 64 /* STABLE_FRAGMENT */))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["data", "onSortChange"])), [
          [_directive_loading, _ctx.isTransactionListLoading]
        ]),
        _createVNode(_component_ListFilterSidebar, {
          title: "Filters",
          "is-filter-active": _ctx.isFilterActive,
          "is-filter-loading": _ctx.isTransactionListsLoading,
          "is-filter-visible": _ctx.isFilterVisible,
          onSubmitFilter: _ctx.submitFilter,
          onResetFilter: _ctx.resetFilter,
          onCloseFilter: _ctx.closeFilter
        }, {
          "filter-content": _withCtx(() => [
            _createVNode(_component_TransactionsFilter)
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["is-filter-active", "is-filter-loading", "is-filter-visible", "onSubmitFilter", "onResetFilter", "onCloseFilter"])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_el_container, { class: "transactions-page__footer" }, {
      default: _withCtx(() => [
        _withDirectives((_openBlock(), _createBlock(_component_el_table, {
          class: "transactions-page__summary-table",
          size: "small",
          "tooltip-effect": "light",
          data: _ctx.transactionListSummaryData,
          border: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactionListSummaryColumns, (column) => {
              return (_openBlock(), _createBlock(_component_el_table_column, {
                key: column.value,
                prop: column.value,
                label: column.label
              }, {
                default: _withCtx(({ row }) => [
                  (column.tagType)
                    ? (_openBlock(), _createBlock(_component_el_tag, {
                        key: 0,
                        type: column.tagType,
                        size: "small"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(row[column.value]), 1 /* TEXT */)
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["type"]))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(row[column.value]), 1 /* TEXT */)
                      ], 64 /* STABLE_FRAGMENT */))
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["prop", "label"]))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _: 1 /* STABLE */
        }, 8 /* PROPS */, ["data"])), [
          [_directive_loading, _ctx.isTransactionListSummaryLoading]
        ])
      ]),
      _: 1 /* STABLE */
    }),
    _createVNode(_component_TokenPagination, {
      "items-per-page-list": _ctx.TRANSACTION_ITEMS_PER_PAGE_LIST,
      onUpdateLimit: _ctx.changeItemsPerPage,
      onChangePage: _ctx.getTransactionLists
    }, null, 8 /* PROPS */, ["items-per-page-list", "onUpdateLimit", "onChangePage"]),
    _createVNode(_component_TwoFactorAuthDialog, { action: _ctx.getTransactionListReport }, null, 8 /* PROPS */, ["action"])
  ], 64 /* STABLE_FRAGMENT */))
}